import { render, staticRenderFns } from "./PromotionsDashboard.vue?vue&type=template&id=f480767e&"
import script from "./PromotionsDashboard.vue?vue&type=script&lang=js&"
export * from "./PromotionsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports